import React, { useState } from 'react'

import validation from '../../../validation'
import AddButton from '../../controls/AddButton'
import RemoveButton from '../../controls/RemoveButton'
import ProviderAutocomplete from '../../ProviderAutocomplete'
import ProviderForm from '../../ProviderForm'

export default {
  name: 'Transportation Services',
  group: 'Providers', // Moved to Providers group
  validationSchema: getValidationSchema(),
  Component,
}

function getValidationSchema() {
  return validation.object({
    transportation: validation
      .arrayOf(
        validation.object({
          providerId: validation.string('Provider ID').required(),
          providerName: validation.string('Provider Name').required(),
        }),
      )
      .nullable(),
  })
}

function Component({ addItemToArray, removeItemFromArray, getValue, ErrorMessage, setModelValues }) {
  const transportation = getValue('transportation', [])
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [activeServiceIndex, setActiveServiceIndex] = useState(null)

  const handleProviderSelect = (index, provider) => {
    if (provider) {
      setModelValues([
        [`transportation[${index}].providerName`, provider.name || provider.organization],
        [`transportation[${index}].providerId`, provider.id],
      ])
    }
  }

  const handleCreateNewProvider = index => {
    setActiveServiceIndex(index)
    setShowCreateModal(true)
  }

  return (
    <div>
      <h4 className="pb-3">Transportation Services</h4>
      {transportation.map((x, index) => {
        const namePrefix = `transportation[${index}]`
        return (
          <React.Fragment key={namePrefix}>
            <div className="clearfix">
              <div className="form-row">
                <div className="form-group col-md-9">
                  <label className="form-label" htmlFor={`${namePrefix}.providerName`}>
                    Service Provider
                  </label>
                  <div className="d-flex align-items-center">
                    <div style={{ flex: 1 }}>
                      <ProviderAutocomplete
                        type="Transportation"
                        onProviderSelect={p => handleProviderSelect(index, p)}
                        onChange={() => {}} // No-op
                        value={x.providerName || ''}
                        placeholder="Search for a provider..."
                      />
                    </div>
                    <div className="ml-3 white-space-nowrap">
                      <span className="mr-1">or</span>
                      <button
                        type="button"
                        className="btn btn-link p-0 align-baseline"
                        onClick={() => handleCreateNewProvider(index)}
                      >
                        Create New Provider
                      </button>
                    </div>
                  </div>
                  <ErrorMessage name={`${namePrefix}.providerName`} />
                </div>
                <div className="col-md-3">
                  <RemoveButton
                    id={`${namePrefix}RemoveBtn`}
                    className="float-right mt-4"
                    onClick={() => removeItemFromArray('transportation', index)}
                  >
                    Remove
                  </RemoveButton>
                </div>
              </div>
            </div>
            <hr />
          </React.Fragment>
        )
      })}
      <AddButton
        id="addTransportationButton"
        onClick={() => {
          addItemToArray('transportation', {})
        }}
      >
        Add Transportation Service
      </AddButton>

      <ProviderForm
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        onSuccess={newProvider => {
          if (activeServiceIndex !== null) {
            handleProviderSelect(activeServiceIndex, newProvider)
          }
          setShowCreateModal(false)
        }}
        initialType="Transportation"
      />
    </div>
  )
}
